<template>
    <div class="products-list__item">
        <div class="product-card">                                                                         
            <div class="cart-table__quantity-search-results cart-table__quantity-search-results--check-stock-tablet product-card__stock-text-search-whi-product-qty">
                <!-- <div class="cart-table__quantity input-number">
                    <input class="form-control-order-entry-qty-selector input-number__input" type="number" min="1" v-model="quantity" data-title="Quantity">
                    <div class="input-number__add"></div>
                    <div class="input-number__sub"></div>
                </div> -->
                <base-quantity-input v-model="quantity"></base-quantity-input>
            </div>
            <button class="product-card__addtocart-icon product-card__addtocart-icon-check-stock-tablet" type="button" aria-label="Add to cart" @click="addToCart(location.location_id)">
                <svg width="20" height="20">
                <circle cx="7" cy="17" r="2"></circle>
                <circle cx="15" cy="17" r="2"></circle>
                <path
                    d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6
        V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4
        C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z"
                ></path>
                </svg>
            </button>																		 
            <button class="product-card__addtocart-full" type="button" @click="addToCart(location.location_id)" > Add to cart </button>
            <div class="product-card__info">                                                        
                <div class="product-card__name">
                    <div class="product-card__badges"></div>
                    <div>                
                        {{location.location + ' (' + location.city + ')'}}
                        <div class="text-cart-item-manufacturer"><span class="text-cart-item-manufacturer">{{location.city + ', ' + location.state}}</span></div>	
                    </div>
                </div>
                <div class="product-card__availability" v-if="mx_product_showStockDisplay">
                    <!-- <availability-display :stock-quantity="location.stockquantity" /> -->
                    <product-stock-display :stock-quantity="location.stockquantity" />
                </div>                                                     
            </div>
            <div class="product-card__footer">
                <div class="product-card__prices">
                    <div v-if="location.on_order > 0" class="product-card__stock product-card__price--current">Stocked</div>

                    <div v-else class="product-card__stock product-card__price--current"><span class="font-backordered" >Not Stocked</span></div>

                    <div class="product-card__stock product-card__price--current">On Order: 
                        <span v-if="location.on_order > 0" class="text-success">{{location.on_order}}</span>
                        <span v-else class="font-backordered">{{location.on_order}}</span>
                    </div>

                    <div v-if="location.on_order > 0" class="product-card__stock product-card__price--current">
                        ETA: {{location.eta_mo + '/' + location.eta_day + '/' + location.eta_yr}}
                    </div>
                    <!-- <div class="product-card__stock product-card__price--current">Rank: {{ location.rank }}</div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import AvailabilityDisplay from './AvailabilityDisplay';
import MixinCart from '../../../mixins/cart.js';
import MixinProduct from '../../../mixins/product.js';
import ProductStockDisplay from '../../common/product/ProductStockDisplay.vue';

export default {
    components: {
        // "availability-display": AvailabilityDisplay,
        ProductStockDisplay
    },
    props : {
        index : {
            type : Number,
        },
        location : {
            type : Object,
            required: true,
        },
        product: {
            type: Object,
            required: true
        },
        sourcePage: {
            type: String
        },
    },
    mixins : [
        MixinCart,
        MixinProduct
    ],
    data() {
        return {
            quantity: 0
        }
    },
    methods: {
        addToCart() {
            this.$store.dispatch("message/clearKeyedMessage", this.sourcePage);
            let linetotal = 0;

            linetotal = this.product.quantity * this.product.yourprice;

            let productData = {
                ID: this.product.sku,
                item: this.product.sku,
                desc: this.product.name,
                manufacturer: this.product.manufacturer,
                image: this.product.image,
                quantity: this.quantity,
                listprice: this.product.listprice,
                corecharge: this.product.coreprice,
                yourprice: this.product.yourprice,
                shipping: 0,
                linetotal: linetotal,

                mfgSeo: this.product.mfgSeo,
                itemSeo: this.product.itemSeo,

                stockquantity: this.location.stockquantity,
                locationid: this.location.location_id,
                locationname: this.location.location,
                locationcity: this.location.city,
                locationstate: this.location.state,

                // new fields
                XRMFGC: this.product.XRMFGC,
                XRITMC: this.product.XRITMC,
                IMIGSA: this.product.IMIGSA,
                IMISVALID: this.product.IMISVALID,
            }

            let validationresult = this.addToCartValidation(productData);

            if (validationresult.status === 'OK') {
                this.$store.dispatch("cart/addToCart", productData);
            } else {
                let storedmessages = [];
                storedmessages.push(validationresult.message);

                this.$store.dispatch("message/addKeyedMessage", {
                    "key": "CheckStock",
                    "messages": storedmessages
                });
            }
        },
    },
    created() {
        this.quantity = 0;
        if (this.location.stockquantity > 0) {
            this.quantity = 1;
        } 
    }
}
</script>